import instance from "@/services/api";
import { buildingSettingsAPI } from "@/views/BuildingSettings/services/api";

export const projectGeodesistsAPI = {
  async getProjectTypes() {
    const res = await buildingSettingsAPI.getProjectTypes();
    return Array.isArray(res) ? res : res?.data ?? [];
  },
  async getWorkSetCheckGroups() {
    return await instance()
      .get("/common/work_set_check_groups/for_sbs/read/")
      .then((res) => res?.data?.data ?? res?.data ?? []);
  },
  async getProjectGeodesists(params = {}) {
    const safeParams = {};
    if (params.project_type_id != null)
      safeParams.project_type_id = params.project_type_id;
    if (params.work_set_check_group_id != null)
      safeParams.work_set_check_group_id = params.work_set_check_group_id;
    return await instance()
      .get("/handbook/project_geodesists/read/", { params: safeParams })
      .then((res) => res?.data?.data ?? res?.data ?? []);
  },
  async addProjectGeodesist(body) {
    return await instance()
      .post("/handbook/project_geodesists/add/", body)
      .then((res) => res?.data?.data ?? res?.data);
  },
  async deleteProjectGeodesist(project_geodesist_id, params = {}) {
    const safeParams = {};
    if (params.project_type_id != null)
      safeParams.project_type_id = params.project_type_id;
    if (params.work_set_check_group_id != null)
      safeParams.work_set_check_group_id = params.work_set_check_group_id;
    return await instance()
      .delete(
        `/handbook/project_geodesists/${project_geodesist_id}/delete/`,
        { params: safeParams }
      )
      .then((res) => res?.data?.data ?? res?.data);
  },
};
